const speakers = window.PhotoX_Speakers;
const photowalks = window.PhotoX_Photowalks;
class PhotoXDialogBox {
 constructor(name, img, followers, ig, website = "", description, metadata, available) {
  this.name = name;
  this.img = img;
  this.followers = followers;
  console.log('Followers:', followers); // Debug here
  this.ig_url = ig;
  this.website = website;
  this.description = description;
  this.scrollPos = window.scrollY;
  this.dialog = null;
  this.metadata = metadata;
  this.available = available;
  this.body = document.querySelector("body");
  this.page = document.querySelector("html");
}

  #_mount(type) {
    const url = this.website?.replace(
      /^(?:https?:\/\/)?(?:www\.)?([^/?]+).*/,
      "$1"
    );
    let html;
    switch (type) {
      case "speaker":
         const socialBadge = this.followers
        ? `
          <div id="PhotoX-Social__Badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" viewBox="0 0 12 13" fill="none">
              <path d="M3.26193 0.834839C1.4633 0.834839 0 2.29814 0 4.09677V9.31586C0 11.1145 1.4633 12.5778 3.26193 12.5778H8.48102C10.2797 12.5778 11.743 11.1145 11.743 9.31586V4.09677C11.743 2.29814 10.2797 0.834839 8.48102 0.834839H3.26193ZM3.26193 2.13961H8.48102C9.56007 2.13961 10.4382 3.01772 10.4382 4.09677V9.31586C10.4382 10.3949 9.56007 11.273 8.48102 11.273H3.26193C2.18288 11.273 1.30477 10.3949 1.30477 9.31586V4.09677C1.30477 3.01772 2.18288 2.13961 3.26193 2.13961ZM9.13341 2.792C8.96039 2.792 8.79445 2.86073 8.6721 2.98308C8.54976 3.10542 8.48102 3.27136 8.48102 3.44438C8.48102 3.61741 8.54976 3.78334 8.6721 3.90569C8.79445 4.02804 8.96039 4.09677 9.13341 4.09677C9.30643 4.09677 9.47237 4.02804 9.59472 3.90569C9.71706 3.78334 9.7858 3.61741 9.7858 3.44438C9.7858 3.27136 9.71706 3.10542 9.59472 2.98308C9.47237 2.86073 9.30643 2.792 9.13341 2.792ZM5.87148 3.44438C4.07285 3.44438 2.60955 4.90769 2.60955 6.70632C2.60955 8.50495 4.07285 9.96825 5.87148 9.96825C7.67011 9.96825 9.13341 8.50495 9.13341 6.70632C9.13341 4.90769 7.67011 3.44438 5.87148 3.44438ZM5.87148 4.74916C6.95052 4.74916 7.82864 5.62727 7.82864 6.70632C7.82864 7.78536 6.95052 8.66348 5.87148 8.66348C4.79243 8.66348 3.91432 7.78536 3.91432 6.70632C3.91432 5.62727 4.79243 4.74916 5.87148 4.74916Z" fill="var(--pl-photox-primary)"/>
            </svg>
            <span>${this.followers}</span>
          </div>
        `
        : ''; // If followers is null, this will render an empty string.
        html = `
            <dialog class="photox-dialog">
              <button class="close_icon" data-element="closeDialog">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M7.49999 15C11.603 15 15 11.5956 15 7.49999C15 3.39706 11.5956 0 7.49264 0C3.39706 0 0 3.39706 0 7.49999C0 11.5956 3.4044 15 7.49999 15ZM5.25 10.9779C4.92647 10.9779 4.68382 10.75 4.68382 10.4486C4.68382 10.2941 4.72058 10.1912 4.81617 10.0515L6.74264 7.38969L4.92647 4.8897C4.80146 4.72058 4.7647 4.61764 4.7647 4.44852C4.7647 4.1397 5.03676 3.88235 5.36029 3.88235C5.61764 3.88235 5.7647 3.97793 5.94117 4.22058L7.55146 6.55882H7.58821L9.17646 4.22793C9.33819 3.97793 9.49262 3.88235 9.72791 3.88235C10.0515 3.88235 10.3014 4.11764 10.3014 4.41911C10.3014 4.55882 10.2647 4.68382 10.1544 4.82352L8.24266 7.42646L10.1397 10.022C10.2426 10.1544 10.2867 10.2647 10.2867 10.4191C10.2867 10.75 10.0294 10.9779 9.68379 10.9779C9.4485 10.9779 9.30883 10.8897 9.11765 10.625L7.48529 8.29409H7.45587L5.81617 10.625C5.61764 10.8897 5.49264 10.9779 5.25 10.9779Z" fill="#D9D9D9"/>
                </svg>
              </button>

              <hgroup class="photox-dialog__hgroup">
                <figure>
                  <img src="${this.img}" alt="${this.name}" />
                </figure>

                <aside>
                  <div>
                    <h2>${this.name}</h2>
                    <p>Guest Speaker</p>
                  </div>
                  
                  <a
                    href="${this.ig_url}"
                    rel="noreferrer"
                    class="ig-follower-badge"
                    data-element="speaker-card_anchor-{{ followers }}"
                    onclick="function(e) { e.stopPropagation(); }"
                    style="display: flex; width: fit-content;"
                    onmouseover="this.style.scale = 1.05; this.style.transition = 'all 0.1s ease';"
                    onmouseleave="this.style.scale = 1; this.style.transition = 'all 0.1s ease';"
                  >
                  
                    ${socialBadge}


                    
                    
                  </a>

                  <a href="${this.website}" target="_blank" class="link link--strong link--underline">${url}</a>
                </aside>
              </hgroup>
              <div class="bio">
                <p>${this.description}</p>
              </div>
              
              <div>
                <button data-element="closeDialog" autofocus class="button button--min-width button--photox button--small">Close</button>
              </div>
            </dialog>
          `;
        break;
      case "event":
        html = `
            <dialog class="photox-dialog" data-type="event">
              <button class="close_icon" data-element="closeDialog">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M7.49999 15C11.603 15 15 11.5956 15 7.49999C15 3.39706 11.5956 0 7.49264 0C3.39706 0 0 3.39706 0 7.49999C0 11.5956 3.4044 15 7.49999 15ZM5.25 10.9779C4.92647 10.9779 4.68382 10.75 4.68382 10.4486C4.68382 10.2941 4.72058 10.1912 4.81617 10.0515L6.74264 7.38969L4.92647 4.8897C4.80146 4.72058 4.7647 4.61764 4.7647 4.44852C4.7647 4.1397 5.03676 3.88235 5.36029 3.88235C5.61764 3.88235 5.7647 3.97793 5.94117 4.22058L7.55146 6.55882H7.58821L9.17646 4.22793C9.33819 3.97793 9.49262 3.88235 9.72791 3.88235C10.0515 3.88235 10.3014 4.11764 10.3014 4.41911C10.3014 4.55882 10.2647 4.68382 10.1544 4.82352L8.24266 7.42646L10.1397 10.022C10.2426 10.1544 10.2867 10.2647 10.2867 10.4191C10.2867 10.75 10.0294 10.9779 9.68379 10.9779C9.4485 10.9779 9.30883 10.8897 9.11765 10.625L7.48529 8.29409H7.45587L5.81617 10.625C5.61764 10.8897 5.49264 10.9779 5.25 10.9779Z" fill="#D9D9D9"/>
                </svg>
              </button>

              <hgroup class="photox-dialog__hgroup">
                <figure>
                  <img src="${this.img}" alt="${this.name}" />
                </figure>

                <aside>
                  <div>
                    <h2>${this.name}</h2>
                    <ul>
                      <li><span>INSTRUCTOR:</span> ${
                        this.metadata.instructor
                      }</li>
                      <li><span>WHERE:</span> ${
                        this.metadata.location_name
                      }</li>
                      <li><span>WHEN:</span> ${this.getWhen(this.metadata)}</li>
                      ${
                        this.metadata.price
                          ? `<li><span>PRICE:</span>${this.formatCurrency(
                              this.metadata.price
                            )}</li>`
                          : ""
                      }
                      ${
                        this.metadata.price
                          ? `<li><span style="font-size: 14px;">1 Photowalk+2 Day Access to PhotoX</span></li>`
                          : ""
                      }
                    </ul>
                  </div>
                </aside>
              </hgroup>

              <div class="bio">
                <p>${this.metadata.short_description}</p>
              </div>
              
              <div class="dialog_actions">
                ${
                  this.metadata.handle
                    ? `<a href="/products/${this.metadata.handle}" class="pl-photox_anchor">Learn More</a>`
                    : ""
                }
                <button data-element="closeDialog" autofocus class="button button--photox__outline button--small">Close</button>
                ${
                  this.metadata.price
                    ? `<form method="post" action="/cart/add"><input type="hidden" name="id" value="${
                        this.metadata.id
                      }"><input min="1" type="number" hidden id="quantity" name="quantity" value="1"><button type="submit" data-type="buyButton" class="button button--small ${
                        this.available ? "button--photox" : "button--disabled"
                      }" ${!this.available ? "disabled" : ""}>${
                        this.available
                          ? "Add to Cart"
                          : this.metadata?.coming_soon
                            ? "Coming Soon"
                            : "Sold Out"
                      }</button></form>`
                    : ""
                }
              </div>
            </dialog>
          `;
      default:
        break;
    }
    this.body.insertAdjacentHTML("beforeend", html);
    this.dialog = document.querySelector("dialog.photox-dialog");
  }
  formatCurrency(value) {
    const money = value.toString();
    return "$" + (money.slice(0, -2) || "0") + "." + money.slice(-2);
  }
  getWhen(metadata) {
    if (metadata?.when?.length) {
      return this.formatDate([...metadata.when]);
    }
    if (metadata?.start_datetime) {
      return this.formatDate([metadata.start_datetime, metadata.end_datetime]);
    }
    return "TBD";
  }
  formatDate([start, end = ""]) {
    const d1 = new Date(start);
    const d2 = end ? new Date(end) : null;
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
    }).format(d1);
    const formattedStartTime = d1
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: !0,
      })
      .toLowerCase()
      .replace(" ", "");
    let formattedEndTime = "";
    if (d2) {
      formattedEndTime =
        "-" +
        d2
          .toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: !0,
          })
          .toLowerCase()
          .replace(" ", "");
    }
    return `${formattedDate} | ${formattedStartTime}${formattedEndTime}`;
  }
  render(type = "speaker") {
    this.#_mount(type);
    this.dialog.showModal();
    this.page.style.overflow = "hidden";
    window.addEventListener(
      "keydown",
      (event) => event.key === "Escape" && this.#_remove()
    );
    document
      .querySelectorAll('dialog button[data-element="closeDialog"]')
      .forEach((button) =>
        button.addEventListener("click", () => this.#_remove())
      );
    document
      .querySelector("dialog")
      .addEventListener("click", () => this.#_remove());
    document
      .querySelector('dialog form > button[type="submit"]')
      ?.addEventListener("click", (event) => {
        event.stopPropagation();
      });
  }
  #_remove() {
    this.dialog.close();
    this.dialog.remove();
    this.page.style.overflow = "auto";
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const speakerCards = document.querySelectorAll(
    'div[data-element="SpeakerCard"]'
  );
  speakerCards.forEach((node) => {
    node.addEventListener("click", (event) => {
      event.stopPropagation();
      const card = event.currentTarget;
      const speakerName = card.dataset.speaker;
      const speaker = JSON.parse(speakers).find(
        (speaker) => speaker.name === speakerName
      );
      const image = "https://" + speaker.image.substring(2);
      const dialog = new PhotoXDialogBox(
        speaker.name,
        image,
        speaker.instagram_follower_count,
        speaker.instagram,
        speaker.website,
        speaker.short_summary,
        null
      );
      dialog.render("speaker");
    });
  });
  const eventCards = document.querySelectorAll(
    'div[data-element="PhotoX-Card"]'
  );
  eventCards.forEach((node) => {
    node.addEventListener("click", () => {
      const { id, title, available } = node.dataset;
      if (!id) {
        const event = window.PhotoX_Events.find((e) => e.name === title);
        if (!event) {
          console.error("Event not found");
          return;
        }
        const metafields = {
          instructor: event.instructor,
          location_name: event.location,
          when: event.date_time,
          short_description: event.description,
        };
        const dialog = new PhotoXDialogBox(
          event.name,
          event.featured_image,
          null,
          null,
          null,
          event.description,
          metafields,
          available
        );
        dialog.render("event");
        return;
      }
      const event = photowalks.find((e) => e.id === parseInt(id));
      if (!event) {
        console.error("PhotoX workshop product not found", { id, title });
        return;
      }
      const [variant] = event.variants || [];
      const normalizeId = (value) => {
        if (!value) return null;
        const str = value.toString();
        const match = str.match(/(\d+)$/);
        return match ? match[1] : str;
      };
      const eventProductId = normalizeId(event.id);
      const foundMetafields = window.PhotoX_Products.find((meta) => {
        const metaProductId = normalizeId(meta?.product?.id || meta?.product_id);
        if (metaProductId && eventProductId && metaProductId === eventProductId) {
          return true;
        }
        const metaHandle = meta?.product?.handle || meta?.product_handle;
        if (metaHandle && metaHandle === event.handle) {
          return true;
        }
        return meta?.name === title;
      });
      if (!foundMetafields) {
        console.warn("PhotoX workshop metaobject missing", {
          id,
          title,
          handle: event.handle,
        });
      }
      const metafields = {
        name: event.title,
        short_description: event.description || event.body_html || "",
        instructor: "",
        location_name: "",
        ...foundMetafields,
        id: variant?.id,
        price: event.variants?.[0]?.price,
        handle: event.handle,
      };
      const isComingSoon = Array.isArray(event.tags)
        ? event.tags.includes("NWA")
        : typeof event.tags === "string" && event.tags.includes("NWA");
      metafields.coming_soon = isComingSoon;
      const missingFields = ["instructor", "location_name", "short_description"].filter(
        (field) => !metafields?.[field]
      );
      if (!metafields?.when && !metafields?.start_datetime) {
        missingFields.push("when_or_start_datetime");
      }
      if (missingFields.length > 0) {
        console.warn("PhotoX workshop metaobject missing fields", {
          id,
          title,
          handle: event.handle,
          missingFields,
        });
      }
      const dialog = new PhotoXDialogBox(
        event.title,
        event.featured_image,
        null,
        null,
        null,
        event.description,
        metafields,
        JSON.parse(available)
      );
      dialog.render("event");
    });
  });
  const accordians = document.querySelectorAll(
    '[data-element="accordian"] > input[type="checkbox"]'
  );
  accordians.forEach((accordian) => {
    accordian.addEventListener("change", (event) => {
      const cheveronIcon =
        event.currentTarget.nextElementSibling.querySelector("span");
      if (event.currentTarget.checked) {
        cheveronIcon.style.transform = "rotate(180deg)";
      } else {
        cheveronIcon.style.transform = "rotate(0deg)";
      }
    });
  });
});

